/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

/**
 * All of the possible `SettingListLink*`'s.
 */
export type SettingListLink = SettingListLinkNext | SettingListLinkPrevious;

/**
 * The Setting List next link type.
 */
export type SettingListLinkNext = typeof SETTING_LIST_LINK_NEXT;

/**
 * The Setting List previous link type.
 */
export type SettingListLinkPrevious = typeof SETTING_LIST_LINK_PREVIOUS;

/**
 * The Setting List next link constant.
 */
export const SETTING_LIST_LINK_NEXT = `next`;

/**
 * The Setting List previous link constant.
 */
export const SETTING_LIST_LINK_PREVIOUS = `prev`;
